<template v-slot:activator="{ on }">
  <v-flex class="form-container py-2" v-if="config" data-qa="form-flex-yd4lmh">
    <v-card
      v-bind:style="config.name === 'AddExternalAC' ? 'box-shadow: none' : ''"
      data-qa="form-card-66w41">
      <v-card-title
        v-if="config.label"
        class="text-h6 font-weight-light pl-6"
        style="opacity: 0.7"
        data-qa="form-card-title-567gpq">{{ config.label }}</v-card-title
      >
      <local-tips v-if="config.tips"
        :config="config.tips"
      />

      <v-row v-if="config.fromAccs" data-qa="form-row-prwbyj">
        <v-flex xs12 sm6 md6 lg6 xl6 class="px-3 pl-9 pt-3" data-qa="form-flex-pcyvei">
        <PaymentSourceSelect
          v-model="fromAccount"
          @input="fromAccChange()"
          :items="config.fromAccs"
          :rules="[rules.requiredRule]"
          :label="$t('localPayments.label.sourceAccount')"
        />
      </v-flex>

      <v-flex xs12 sm6 md6 lg6 xl6 class="px-2 pr-9 pt-3" data-qa="form-flex-vv1b8d">
        <v-text-field
          v-model="toAccount"
          @focus="openPayee()"
          :hint="hint ? hint : ''"
          :color="primaryColor"
          :label="$t('localPayments.label.selectPayee')"
          filled
          readonly
          persistent-hint
          :rules="[rules.requiredRule]"
          append-icon="mdi-chevron-right"
          class="transferFunds--custom-textfield"
          data-qa="form-text-field-r11mzj"></v-text-field>
      </v-flex>
      </v-row>

      <v-card-text class="pb-0" data-qa="form-card-text-e3kt2b">
        <v-form
          ref="form"
          v-if="config.form"
          v-model="valid"
          :lazy-validation="false"
          data-qa="form-form-3imhj9">
          <v-form-base
            v-if="config.form.model && config.form.schema"
            :value="config.form.model"
            :schema="config.form.schema"
            :formCheck="checkFormSanity(config.form.schema, config.form.model)"
            @blur="
              isFormValid(valid);
              callParentMethods($event, 'blur');
            "
            @input="
              isFormValid(valid);
              $emit('onInput', $event);
              toggleDisable(config.form.model, $event);
              validateRegEx($event);
              onFieldChange($event);
              callParentMethods($event, 'input');
            "
            @update="onFieldChange"
            @click="onFieldClick($event); onAppendIcon($event)"
            @change="toggleRegex($event); onChange($event)"
            @focus="callParentMethods($event, 'focus')"
            class="pt-2"
            data-qa="form-form-base-oub8vs">
          <template v-slot:select-custom-prependItem-slot="{ schema }">
            <v-text-field
              v-model="search"
              @input="filterItems(schema)"
              @blur="handleBlur(schema)"
              append-icon="mdi-magnify"
              :label="schema?.slots?.['prepend-item']?.label || 'Search'"
              single-line
              hide-details
              :style="schema?.slots?.['prepend-item']?.style"
              :color="primaryColor"
              data-qa="form-text-field-2ftakx"></v-text-field>
          </template>
          <template v-slot:select-custom-item-slot="{ item, on, attrs, schema }">
            <v-list-item v-bind="attrs" v-on="on" v-if="!isSearchItemAvailable && schema?.items.length === 1" disabled data-qa="form-list-item-swp4ej">
              <v-list-item-content data-qa="form-list-item-content-ksh1mts">
                <v-list-item-title :style="{ color: 'black' }" data-qa="form-list-item-title-qczqrr">{{ $t('accountStatements.noDataAvailable') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-bind="attrs" v-on="on" v-else :style="getComputedStyle(item, schema)" data-qa="form-list-item-pousi2">
              <v-list-item-icon v-if="schema?.slots?.item?.prependIcon" data-qa="form-list-item-icon-2vz12e">
                <country-flag :country='item[schema?.slots?.item?.prependIconKey]' size='normal'/>
              </v-list-item-icon>
              <v-list-item-content data-qa="form-list-item-content-84nezh">
                <v-list-item-title :style="{'width': '200px', 'text-wrap': 'auto'}" data-qa="form-list-item-title-tcasjo">{{ item[schema?.slots?.item?.displayTextKey || schema['item-text']] }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon v-if="schema?.slots?.item?.appendText" data-qa="form-list-item-icon-6s3rz7">
                <span class="grey--text" data-qa="form-span-lh6juw">{{ item[schema?.slots?.item?.appendTextKey] }}</span>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <template v-slot:select-custom-selection-slot="{ item, on, attrs, schema }">
            <div v-bind="attrs" v-on="on" :style="schema?.slots?.selection?.style" data-qa="form-div-nn3x3v">
              <div v-if="schema?.slots?.selection?.prependIcon" data-qa="form-div-h41isf">
                <country-flag :country='item[schema?.slots?.item?.prependIconKey]' size='normal'/>
              </div>
              <div data-qa="form-div-2wjp96">
                <span data-qa="form-span-3w7tm7">{{ item[schema?.slots?.selection?.displayTextKey || schema['item-text']] }}</span>
              </div>
            </div>
          </template>
          </v-form-base>
        </v-form>
      </v-card-text>
      <slot name="formActions" data-qa="form-slot-dre1rr"></slot>
    </v-card>
  </v-flex>
</template>

<script>
/* eslint-disable no-param-reassign */
import '@/styles/components/form.scss'
import VFormBase from 'dco-vuetify-form'
import event from '@/util/event'
import formFieldsMixin from '@/core/mixins/formFieldsMixin'
import LocalTips from '../../views/payments/InterBankPayments/LocalPayments/LocalTips.vue'
import PaymentSourceSelect from '../../views/common/PaymentSourceSelect.vue'
import CountryFlag from 'vue-country-flag'

export default {
  name: 'Form',
  components: {
    VFormBase,
    LocalTips,
    PaymentSourceSelect,
    CountryFlag
  },
  mixins: [formFieldsMixin],
  props: {
    config: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      fromAccount: '',
      toAccount: '',
      hint: '',
      enableFileComponent: false,
      valid: true,
      component: undefined,
      key: undefined,
      orientation: 'bottom',
      enableComponent: false,
      componentInput: undefined,
      arg: undefined,
      isFileValid: true,
      persistData: undefined,
      isDataPreloaded: false,
      toggleEdit: true,
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field'
      },
      search: '',
      isSearchItemAvailable: undefined
    }
  },
  created () {
    event.$emit('isValid', this.valid)
    event.$on('disableForm', (arg) => {
      this.toggleManual(this.config.form.schema, true)
    })
    event.$on('resetEditToggle', (arg) => {
      this.toggleEdit = arg
    })
    event.$on('setSelectedPayee', (acc, hint) => {
      this.hint = hint
      this.toAccount = acc
    })
    event.$on('setSelectedDbtr', (dbtr) => {
      this.fromAccount = dbtr
    })
    event.$on('resetForm', (arg) => {
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
    })
    event.$on('validateForm', (arg) => {
      if (this.$refs.form && arg) {
        this.$refs.form.validate()
      }
    })
    event.$on('resetFormValidation', (arg) => {
      if (this.$refs.form && arg) {
        this.$refs.form.resetValidation()
      }
    })
  },
  methods: {
    getComputedStyle (i, s) {
      const { 'data-qa': dq } = s
      const { form: { schema: { [dq]: { 'item-value': itemValue = undefined } = {} } = {}, model: { [dq]: currentSelectedValue } = {} } = {} } = this.config

      let hideItem = i[itemValue] === currentSelectedValue

      if (dq === 'countryCode') {
        const [cdc, cc] = currentSelectedValue.split('_')
        hideItem = i.dial_code === cdc && i.code === cc
      }

      if (!this.isSearchItemAvailable && hideItem) {
        return { display: 'none' }
      }

      return {}
    },
    filterItems (s) {
      const { 'data-qa': dq } = s
      const originalItems = JSON.parse(localStorage.getItem(dq))
      const { form: { schema: { [dq]: { items = [], 'item-value': itemValue = undefined, slots: { item: { displayTextKey, appendTextKey } = {} } = {} } = {} } = {}, model: { [dq]: currentSelected } = {} } = {} } = this.config

      let callBackFn = (i) => i[itemValue] === currentSelected

      if (dq === 'countryCode') {
        const [cdc, cc] = currentSelected.split('_')
        callBackFn = i => i.code === cc && i.dial_code === cdc
      }

      if (items && this.search) {
        this.config.form.schema[dq].items = originalItems.filter((item) => {
          return item[displayTextKey].toLowerCase().includes(this.search.toLowerCase()) || (appendTextKey && item[appendTextKey].toLowerCase().includes(this.search.toLowerCase()))
        })
        if (!this.config.form.schema[dq].items.find(callBackFn)) {
          const csi = originalItems.find(callBackFn)
          this.config.form.schema[dq].items.push(csi)
          this.isSearchItemAvailable = false
        } else {
          this.isSearchItemAvailable = true
        }
      } else {
        this.config.form.schema[dq].items = originalItems
        this.isSearchItemAvailable = true
      }
    },
    handleBlur (s) {
      this.search = ''
      const { 'data-qa': dq } = s
      const originalItems = JSON.parse(localStorage.getItem(dq))
      if (this.config?.form?.schema?.[dq]?.items) this.config.form.schema[dq].items = originalItems
    },
    fromAccChange () {
      event.$emit('fromAccChange', this.fromAccount)
    },
    onBlur (event) {
      this.isFormValid(event)
    },
    isFormValid (e) {
      event.$emit('isValid', this.valid)
    },
    onAppendIcon ({ obj }) {
      if (['PersonalDetails', 'ResidentialAddress', 'CorrespondenceAddress'].includes(this.config.name)) {
        const { key } = obj
        if (key === 'searchResidentialAddress' || key === 'searchCorrespondenceAddress') {
          this.processSearchField(obj)
        }
      }
    },
    processSearchField ({ key, value }) {
      // TODO: should not be hardcoded to 3 must be based on minLen configuration
      // Bypass if less than 3 char
      if (!value || value.length < 3) return
      event.$emit('triggerAddressLookup', { searchKey: key, searchValue: value })
    },
    openPayee () {
      event.$emit('togglePayee')
    },
    onFieldClick ({ data, obj, key }) {
      if (key === 'uploadResidentialProofBtn') {
        this.$emit('onUploadResidentialProofBtnClick')
        return
      }
      if (key === 'uploadCorrespondenceProofBtn') {
        this.$emit('onUploadCorrespondenceProofBtnClick')
        return
      }
      if (obj) {
        const { schema } = obj
        let value = ''
        const validateField = obj.schema['data-relation']

        if (!this.config.form.model[validateField]) {
          this.config.form.model[validateField] = undefined
        }

        if (schema['data-type']) {
          this.component = schema['data-type']
        }
        if (schema['data-relation']) {
          value = this.config.form.model[schema['data-relation']]
        }
        if (this.component && value) {
          if (
            schema['trigger-info'] === 0 ||
            value.length >= schema['trigger-info']
          ) {
            this.enableComponent = true
          }
        }
        this.componentInput = data[schema['data-relation']]
        this.emitUpdated(data)
      }
    },
    emitUpdated (data) {
      this.$emit('update', {
        data,
        schema: this.config.form.schema
      })
    },
    handleIconClicked (schema) {
      event.$emit('disableSaveIni', this.toggleEdit)
      this.toggleManual(schema, !this.toggleEdit)
      if (!this.toggleEdit) {
        event.$emit('restoreForm', this.config.name)
      }
      this.toggleEdit = !this.toggleEdit
    },
    getEnabledKey (schema, searchKey) {
      return Object.keys(schema)
        .filter((key) => schema[key][searchKey])
        .toString()
    },
    onFieldChange ({ data, obj }) {
      if (obj) {
        const { key, schema, value } = obj
        const inputValue = data[key]
        const { componentKeyEnable } = schema

        if (componentKeyEnable) {
          this.key = componentKeyEnable
        }
        if (schema['data-type']) {
          this.component = schema['data-type']
        }
        if (this.component && inputValue) {
          if (
            schema['trigger-length'] === 0 ||
            inputValue.length >= schema['trigger-length']
          ) {
            this.enableComponent = true
          }
        }
        if (schema.type === 'calendar') {
          this.formatDate(value, key)
        }
        this.componentInput = data[schema['data-relation']]
        this.emitUpdated(data)
      }
    },
    callParentMethods (e, action) {
      const formName = ['ActivateUser', 'ForgotLoginID', 'ForgotPassword']
      if (e.key === 'countryCode' && ['blur', 'input'].includes(e.on) && this.search) this.search = undefined
      if (formName.includes(this.config.name)) {
        switch (action) {
          case 'blur': {
            if (e.key === 'phoneNumber' && e.schema?.phoneNumber?.regex && !e.data?.phoneNumber.match(e.schema?.phoneNumber?.regex)) break
            event.$emit('checkLoginScreenAction', { e, action: 'blur' })
            break
          }
          case 'input': {
            if (e.key === 'countryCode' && e.schema?.phoneNumber?.regex && !e.data?.phoneNumber.match(e.schema?.phoneNumber?.regex)) break
            event.$emit('checkLoginScreenAction', { e, action: 'input' })
            break
          }
          case 'focus':
            if (e.key === 'phoneNumber') {
              if (e?.schema?.phoneNumber?.error) {
                e.schema.phoneNumber.error = false
                e.schema.phoneNumber['error-messages'] = ''
              }
              event.$emit('checkLoginScreenAction', { e, action: 'focus' })
            }
            break
          default:
        }
      }
      if (this.config.name === 'DomesticPayments' && action === 'focus') {
        if (e.key === 'payeeAccount') {
          this.openPayee()
        }
      }
      if (this.config.name === 'BillPayments') {
        event.$emit('checkAccountBalance', { e, action })
      }
      if (this.config.name === 'AddExternalAC') {
        event.$emit('openBeneficiaryAccValidations', { e, action })
      }
      const profileForms = ['PersonalDetails', 'SmeDetails', 'SmePersonalDetails', 'ResidentialAddress', 'CorrespondenceAddress']
      if (profileForms.includes(this.config.name)) event.$emit('editCheck', true)
    },
    onChange ({ value, key }) {
      if (key === 'sameAsResidential') {
        this.$emit('onSameAsResidentialChange', { selected: value })
      }
    }
  },
  watch: {
    valid () {
      this.$emit('isValid', this.valid, this.config.name)
      event.$emit('isValid', this.valid, this.config.name)
    }
  }
}
</script>
